import BillVersionModel from './bill_version_model';
export default Backbone.Collection.extend({
  model: BillVersionModel,
  comparator: "version"
});